import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TemplateAttachment } from '../../models/template-attachment/template-attachment.model';

@Injectable()
export class TemplateAttachmentApiService {
  private readonly baseUrl = `${environment.apiBaseUrl}/template-files`;

  constructor(private http: HttpClient) {}

  list(category: 'tenant' | 'owner' | 'key'): Observable<TemplateAttachment[]> {
    return this.http.get<TemplateAttachment[]>(`${this.baseUrl}`, {
      params: { category }
    });
  }

  upload(category: 'tenant' | 'owner' | 'key', file: File): Observable<TemplateAttachment> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('category', category);

    return this.http.post<TemplateAttachment>(`${this.baseUrl}`, formData);
  }

  download(id: string): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/${id}/download`, {
      responseType: 'blob'
    });
  }

  remove(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
}
